document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 750) {
        new Swiper('.customer-reviews-section .reviews-swiper', {
            pagination: { el: '.customer-reviews-section .swiper-pagination' },
            paginationClickable: true,
            grabCursor: true,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
        });
    }
});